import { configureStore } from "@reduxjs/toolkit";
import projectsSlice from "./slices/projectsSlice";
import newsSlice from "./slices/newsSlice";
import partnersSlice from "./slices/partnersSlice";
import statisticsSlice from "./slices/statisticsSlice";
import korbaSlice from "./slices/korbaSlice";
import recipientSlice from "./slices/recipientSlice";
import donationSlice from "./slices/donationSlice";
import sponsorSlice from "./slices/sponsorSlice";
import moyasarSlice from "./slices/moyasarSlice";
import loginSlice from "./slices/loginSlice";
import branchesSlice from "./slices/branchesSlice";
import ServicesSlice from "./slices/servicesSlice";
import photoVideoSlice from "./slices/photoVideoSlice";
import reportsSlice from "./slices/reportsSlice";
import partnershipSlice from "./slices/partnershipSlice";
import contactSlice from "./slices/contactSlice";
import programsSlice from "./slices/programsSlice";
import palmSlice from "./slices/palmSlice";
import sponsorshipSlice from "./slices/sponsorshipSlice";
import scholarshipsSlice from "./slices/scholarshipSlice";
import generalDonationSlice from "./slices/generalDonationSlice";
import surveySlice from "./slices/surveySlice";
import monitoringSlice from "./slices/monitoringSlice";
import jobsSlice from "./slices/jobsSlice";
import participantsSlice from "./slices/participantsSlice";
import ratingSlice from "./slices/ratingSlice";
import schoolSlice from "./slices/schoolSlice";
import objectiveSlice from "./slices/objectivesSlice";
import visionsMessionsSlice from "./slices/visionMessionsSlice";
const store = configureStore({
  reducer: {
    palm: palmSlice,
    recipient: recipientSlice,
    projects: projectsSlice,
    news: newsSlice,
    partners: partnersSlice,
    statistics: statisticsSlice,
    korbas: korbaSlice,
    donation: donationSlice,
    sponsor: sponsorSlice,
    moyasar: moyasarSlice,
    login: loginSlice,
    branches: branchesSlice,
    services: ServicesSlice,
    photoVideo: photoVideoSlice,
    reports: reportsSlice,
    partnership: partnershipSlice,
    contact: contactSlice,
    programs: programsSlice,
    scholarship: scholarshipsSlice,
    sponsorship: sponsorshipSlice,
    generalDonations: generalDonationSlice,
    survey: surveySlice,
    monitoring: monitoringSlice,
    jobs: jobsSlice,
    participants: participantsSlice,
    rating: ratingSlice,
    school: schoolSlice,
    objectives: objectiveSlice,
    visions: visionsMessionsSlice,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
